export const DESCRIPTION_TAB = 'DESCRIPTION_TAB';
export const SPECIFICATION_TAB = 'SPECIFICATION_TAB';
export const HELP_TAB = 'HELP_TAB';
export const ASSEMBLY_TAB = 'ASSEMBLY_TAB';
export const INGREDIENTS_TAB = 'INGREDIENTS_TAB';
export const NUTRITIONALCONTENT_TAB = 'NUTRITIONALCONTENT_TAB';
export const TECHNOLOGY_TAB = 'TECHNOLOGY_TAB';
export const BRAND_TAB = 'BRAND_TAB';
export const REVIEWS_TAB = 'REVIEWS_TAB';
export const BILDER_TAB = 'BILDER_TAB';
export const FAREINDIKASJONER_TAB = 'FAREINDIKASJONER_TAB';
export const GEOMETRI_TAB = 'GEOMETRI_TAB';
export const SPESIFIKASJONER_TAB = 'SPESIFIKASJONER_TAB';
export const TESTER_TAB = 'TESTER_TAB';
export const TILLEGGSINFORMASJON_TAB = 'TILLEGGSINFORMASJON_TAB';
export const VIDEO_TAB = 'VIDEO_TAB';

export const EDITOR_TYPE = 'EDITOR';
export const BRAND_TYPE = 'BRAND';
export const REVIEWS_TYPE = 'REVIEWS';